/**
 * Line icons per cost type (Umlage-Assistent, receipts): 20×20 grid, stroke = currentColor, round caps and joins, the
 * same style as the web and mobile icon sets. One source for both apps; keys are the cost categories of
 * @immoaktas/shared (COST_CATEGORIES).
 */
export const COST_ICON_PATHS = {
  property_tax: 'M3 8 L10 3.5 L17 8 Z M5 8 V15 M8.3 8 V15 M11.7 8 V15 M15 8 V15 M2.5 17 H17.5',
  water: 'M10 2.5 C10 2.5 4.5 8.8 4.5 12.3 a5.5 5.5 0 0 0 11 0 C15.5 8.8 10 2.5 10 2.5 Z',
  sewage:
    'M2.5 6 C5 4 7.5 8 10 6 C12.5 4 15 8 17.5 6 M2.5 10.5 C5 8.5 7.5 12.5 10 10.5 C12.5 8.5 15 12.5 17.5 10.5 M2.5 15 C5 13 7.5 17 10 15 C12.5 13 15 17 17.5 15',
  heating:
    'M10 17.5 a5 5 0 0 1 -5 -5 C5 9 8 7.5 8 3 C11 5 15 8 15 12.5 a5 5 0 0 1 -5 5 Z M10 17.5 a2 2 0 0 1 -2 -2 C8 13.8 10 13 10 11.2 C11.5 12.5 12 14 12 15.5 a2 2 0 0 1 -2 2',
  hot_water:
    'M2.5 8 H11 a4 4 0 0 1 4 4 V12.5 M6.5 8 V5 M4.5 5 H8.5 M15 15.5 V16.5 M12.5 17 V17.5 M17.5 17 V17.5',
  elevator: 'M4 2.5 H16 V17.5 H4 Z M7.5 8 L10 5.5 L12.5 8 M7.5 12 L10 14.5 L12.5 12',
  street_cleaning: 'M15.5 2.5 L10.5 9.5 M7 8.5 L13 11.5 L11 17.5 H3.5 Z M6 17.5 L7.5 13 M8.5 17.5 L9.8 13.8',
  waste: 'M4 5.5 H16 M8 5.5 V3.5 H12 V5.5 M5.5 5.5 L6.5 17 H13.5 L14.5 5.5 M8.5 9 V14 M11.5 9 V14',
  building_cleaning:
    'M8 3 L9.3 7.7 L14 9 L9.3 10.3 L8 15 L6.7 10.3 L2 9 L6.7 7.7 Z M15 12 L15.6 14.4 L18 15 L15.6 15.6 L15 18 L14.4 15.6 L12 15 L14.4 14.4 Z',
  pest_control:
    'M10 6 a3.5 4.5 0 0 1 3.5 4.5 V12.5 a3.5 4.5 0 0 1 -7 0 V10.5 A3.5 4.5 0 0 1 10 6 Z M10 8 V17 M7.5 4 L8.5 6 M12.5 4 L11.5 6 M3 9 L6.5 10 M17 9 L13.5 10 M3 15 L6.5 13.5 M17 15 L13.5 13.5',
  garden:
    'M10 17.5 V10 M10 10 C5 10 3.5 6.5 4 3 C8 3 10 5.5 10 10 Z M10 12.5 C14.5 12.5 16 9 15.5 6 C12 6 10 8.5 10 12.5 Z',
  common_electricity:
    'M7.5 14 V12.5 C5.5 11.3 4.5 9.5 4.5 7.8 a5.5 5.5 0 0 1 11 0 C15.5 9.5 14.5 11.3 12.5 12.5 V14 Z M8 17 H12',
  chimney: 'M2.5 10.5 L10 4 L17.5 10.5 M4.5 9 V17 H15.5 V9 M12.5 5.8 V2.5 H15 V8',
  insurance:
    'M10 2.5 L16 5 V9.5 C16 13.5 13.5 16 10 17.5 C6.5 16 4 13.5 4 9.5 V5 Z M7.5 10 L9.3 11.8 L12.8 8.2',
  caretaker: 'M6.5 16.5 a3.5 3.5 0 1 1 0.01 0 M9 10.5 L16.5 3 M14 5.5 L16 7.5 M12 7.5 L13.5 9',
  antenna_cable: 'M10 10 V17.5 M7 17.5 H13 M10 10 L5 3 M10 10 L15 3 M7.5 6.5 H12.5',
  laundry: 'M4 2.5 H16 V17.5 H4 Z M4 6 H16 M10 15 a3.5 3.5 0 1 1 0.01 0 M6.5 4.2 H7.5',
  other_operating: 'M5 5.5 H5.1 M8 5.5 H16 M5 10 H5.1 M8 10 H16 M5 14.5 H5.1 M8 14.5 H16',
} as const;
export type CostIconKey = keyof typeof COST_ICON_PATHS;
